<h3 class="heading" *ngIf="movements">{{ "RANKING.LAST-MOVIMENT" | translate }}</h3>
<div class="best-movements" *ngIf="movements">
    <nb-tabset>
        <nb-tab tabTitle="{{ 'GENERAL.UP' | translate }}" *ngIf="movements.up">
            <div>
                <ng-container
                    [ngTemplateOutlet]="moveDownTemplateDesktop"
                    [ngTemplateOutletContext]="{ movements: movements.up }"
                ></ng-container>
            </div>
        </nb-tab>
        <nb-tab tabTitle="{{ 'GENERAL.DOWN' | translate }}" *ngIf="movements.down">
            <div>
                <ng-container
                    [ngTemplateOutlet]="moveDownTemplateDesktop"
                    [ngTemplateOutletContext]="{ movements: movements.down }"
                ></ng-container>
            </div>
        </nb-tab>
    </nb-tabset>
</div>

<ng-template #moveDownTemplateDesktop let-movements="movements">
    <ngb-carousel [showNavigationArrows]="movements.length > 1">
        <ng-template ngbSlide *ngFor="let moveDown of movements">
            <div>
                <p class="movement-description text-hint mb-2 text-center text-lg-left">{{ moveDown.categoryName }}</p>
                <div class="row justify-content-center justify-content-lg-start row-movement">
                    <div class="col-auto" *ngFor="let player of moveDown.players">
                        <div class="player-box">
                            <img [src]="player.url_avatar" [alt]="player.nome" />
                            <div class="player-info">
                                <p class="player-name">{{ player.nome }}</p>
                                <div class="player-move">
                                    <fa-icon
                                        [style.color]="getColorByMove(player.posicoes_movtos)"
                                        [icon]="getIconByMove(player.posicoes_movtos)"
                                    ></fa-icon>
                                    <span class="ml-1">{{ player.posicoes_movtos }}</span>
                                </div>
                                <span class="player-pos">{{ player.posicao }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </ngb-carousel>
</ng-template>

<ng-template #moveDownTemplateMobile let-movements="movements">
    <div *ngFor="let moveDown of movements">
        <p class="movement-description text-hint mb-2">{{ moveDown.categoryName }}</p>
        <ngb-carousel>
            <ng-template ngbSlide *ngFor="let player of moveDown.players">
                <div class="col-auto">
                    <div class="player-box">
                        <img [src]="player.url_avatar" [alt]="player.nome" />
                        <div class="player-info">
                            <p class="player-name">{{ player.nome }}</p>
                            <span class="player-pos">{{ player.posicao }}</span>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ngb-carousel>
    </div>
</ng-template>
